angular.module('aprima-core-ui').directive('iframeOnload', [function(){
        'use strict';
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function(scope, element){
                element.on('load', function(){
                    return scope.callBack();
                });

                scope.$on('$destroy', function () {
                    element.off('load');
                });
            }
        };
    }]);